jQuery(document).ready(function($){
	if (window.innerWidth <= 767) {
		$('.custOpenIcon').click(function(){
			$('.custHdrMainBtm').addClass('menuActive');
		});
		$('.custCloseIcon').click(function(){
			$('.custHdrMainBtm').removeClass('menuActive');
		});
		$(".custHdrMenuMobile .has-submenu > a").on("click", function (e) {
			e.preventDefault();
			let parentLi = $(this).parent(".has-submenu");
			let submenu = parentLi.children(".submenu");
			submenu.slideToggle(300);
			parentLi.siblings(".has-submenu").find(".submenu").slideUp(300);
	    });
	}

    setTimeout(function() {
        $(".shopify-section-group-header-group")
            .contents()
            .filter(function() {
                return this.nodeType === 3 && this.nodeValue.trim() === "'";
            })
            .remove();

        $('.custInrBlgDate').insertAfter('#article-banner');
    }, 500);
		
});

function autoPlayVideo() {
    var video = document.querySelector('.custHomePageSec1 video');
    if (video) {
        video.muted = true;
        video.autoplay = true;
        video.loop = true;
        video.removeAttribute('controls');
        setTimeout(() => {
            video.play().catch(()=>{});
        }, 200);
    }
}

document.addEventListener('DOMContentLoaded', autoPlayVideo);
document.addEventListener('shopify:section:load', autoPlayVideo);


document.addEventListener('DOMContentLoaded', function () {
    var path = window.location.pathname.replace(/\/$/, '');
    var page = path.substring(path.lastIndexOf('/') + 1) || 'home';
    var className = 'page-' + page.toLowerCase().replace(/[^a-z0-9\-]/g, '-');
    document.body.classList.add(className);
});




